<div class="demo-block-card">
  <div class="demo-block-close" (click)="dismiss()">
    <span class="material-icons">close</span>
  </div>
  <div class="demo-block-icon">
    <span class="material-icons">rocket_launch</span>
  </div>
  <div class="demo-block-title">
    <tidy-text [largeTitle]="prompt.title" />
  </div>
  <div class="demo-block-body">
    <tidy-text [body]="prompt.body" />
  </div>
  <div class="demo-block-actions">
    <!-- The prompt can be opened from a tidy-button, whose global loading overlay lands on the
         stack asynchronously — often after this modal has rendered. This view is OnPush, so it
         would latch that stale "disabled" until a click forced a re-check. A modal's own CTA
         should never wait on a background overlay: opt out of the shared loading state. -->
    <tidy-button
      [text]="prompt.buttonLabel"
      [action]="getStarted"
      [disableLoadingStyle]="true"
      class="primary full-width" />
  </div>
</div>
